import { useBreakpoints as vueuseBreakpoints, useWindowSize } from '@vueuse/core'
import { FUNNOW_BREAKPOINTS } from '@/constants/theme'

export function useBreakpoints() {
  const breakpointsCtx = vueuseBreakpoints(FUNNOW_BREAKPOINTS)
  const device = useDevice()
  const { width: windowWidth } = useWindowSize({
    // The minus one guarantees we fall just below the xs threshold (e.g. 599 < 600) so "isMobile" logic works as expected.
    initialWidth: device.isMobile ? FUNNOW_BREAKPOINTS.xs - 1 : FUNNOW_BREAKPOINTS.lg,
    initialHeight: 0,
  })

  const breakpoints = reactive({
    xs: breakpointsCtx.smaller('sm'),
    sm: breakpointsCtx.between('sm', 'md'),
    md: breakpointsCtx.between('md', 'lg'),
    lg: breakpointsCtx.between('lg', 'xl'),
    xsAndDown: breakpointsCtx.smaller('xs'),
    xsAndUp: breakpointsCtx.greater('xs'),
    smAndDown: breakpointsCtx.smaller('sm'),
    smAndUp: breakpointsCtx.greater('sm'),
    mdAndDown: breakpointsCtx.smaller('md'),
    mdAndUp: breakpointsCtx.greater('md'),
    lgAndDown: breakpointsCtx.smaller('lg'),
    lgAndUp: breakpointsCtx.greater('lg'),
  })

  const isMobile = computed(() => windowWidth.value < FUNNOW_BREAKPOINTS.xs)

  return {
    breakpoints,
    isMobile,
  }
}
